module.exports = __webpack_public_path__ + "img/icon_phoneSolid.b37da265.svg";